import $ig74W$arAEmodulejs from "./ar-AE.mjs";
import $ig74W$bgBGmodulejs from "./bg-BG.mjs";
import $ig74W$csCZmodulejs from "./cs-CZ.mjs";
import $ig74W$daDKmodulejs from "./da-DK.mjs";
import $ig74W$deDEmodulejs from "./de-DE.mjs";
import $ig74W$elGRmodulejs from "./el-GR.mjs";
import $ig74W$enUSmodulejs from "./en-US.mjs";
import $ig74W$esESmodulejs from "./es-ES.mjs";
import $ig74W$etEEmodulejs from "./et-EE.mjs";
import $ig74W$fiFImodulejs from "./fi-FI.mjs";
import $ig74W$frFRmodulejs from "./fr-FR.mjs";
import $ig74W$heILmodulejs from "./he-IL.mjs";
import $ig74W$hrHRmodulejs from "./hr-HR.mjs";
import $ig74W$huHUmodulejs from "./hu-HU.mjs";
import $ig74W$itITmodulejs from "./it-IT.mjs";
import $ig74W$jaJPmodulejs from "./ja-JP.mjs";
import $ig74W$koKRmodulejs from "./ko-KR.mjs";
import $ig74W$ltLTmodulejs from "./lt-LT.mjs";
import $ig74W$lvLVmodulejs from "./lv-LV.mjs";
import $ig74W$nbNOmodulejs from "./nb-NO.mjs";
import $ig74W$nlNLmodulejs from "./nl-NL.mjs";
import $ig74W$plPLmodulejs from "./pl-PL.mjs";
import $ig74W$ptBRmodulejs from "./pt-BR.mjs";
import $ig74W$ptPTmodulejs from "./pt-PT.mjs";
import $ig74W$roROmodulejs from "./ro-RO.mjs";
import $ig74W$ruRUmodulejs from "./ru-RU.mjs";
import $ig74W$skSKmodulejs from "./sk-SK.mjs";
import $ig74W$slSImodulejs from "./sl-SI.mjs";
import $ig74W$srSPmodulejs from "./sr-SP.mjs";
import $ig74W$svSEmodulejs from "./sv-SE.mjs";
import $ig74W$trTRmodulejs from "./tr-TR.mjs";
import $ig74W$ukUAmodulejs from "./uk-UA.mjs";
import $ig74W$zhCNmodulejs from "./zh-CN.mjs";
import $ig74W$zhTWmodulejs from "./zh-TW.mjs";

var $90339528ca3fdd88$exports = {};


































$90339528ca3fdd88$exports = {
    "ar-AE": $ig74W$arAEmodulejs,
    "bg-BG": $ig74W$bgBGmodulejs,
    "cs-CZ": $ig74W$csCZmodulejs,
    "da-DK": $ig74W$daDKmodulejs,
    "de-DE": $ig74W$deDEmodulejs,
    "el-GR": $ig74W$elGRmodulejs,
    "en-US": $ig74W$enUSmodulejs,
    "es-ES": $ig74W$esESmodulejs,
    "et-EE": $ig74W$etEEmodulejs,
    "fi-FI": $ig74W$fiFImodulejs,
    "fr-FR": $ig74W$frFRmodulejs,
    "he-IL": $ig74W$heILmodulejs,
    "hr-HR": $ig74W$hrHRmodulejs,
    "hu-HU": $ig74W$huHUmodulejs,
    "it-IT": $ig74W$itITmodulejs,
    "ja-JP": $ig74W$jaJPmodulejs,
    "ko-KR": $ig74W$koKRmodulejs,
    "lt-LT": $ig74W$ltLTmodulejs,
    "lv-LV": $ig74W$lvLVmodulejs,
    "nb-NO": $ig74W$nbNOmodulejs,
    "nl-NL": $ig74W$nlNLmodulejs,
    "pl-PL": $ig74W$plPLmodulejs,
    "pt-BR": $ig74W$ptBRmodulejs,
    "pt-PT": $ig74W$ptPTmodulejs,
    "ro-RO": $ig74W$roROmodulejs,
    "ru-RU": $ig74W$ruRUmodulejs,
    "sk-SK": $ig74W$skSKmodulejs,
    "sl-SI": $ig74W$slSImodulejs,
    "sr-SP": $ig74W$srSPmodulejs,
    "sv-SE": $ig74W$svSEmodulejs,
    "tr-TR": $ig74W$trTRmodulejs,
    "uk-UA": $ig74W$ukUAmodulejs,
    "zh-CN": $ig74W$zhCNmodulejs,
    "zh-TW": $ig74W$zhTWmodulejs
};


export {$90339528ca3fdd88$exports as default};
//# sourceMappingURL=intlStrings.module.js.map
